<template>
  <div class="topbar" >
    <div class="columns is-menu is-gapless is-vcentered">
      <div class="column is-8"></div>
      <div class="column has-text-centered">
        <router-link :to="'/' + $i18n.locale + '/'">
          <span class="icon is-small is-left is-home">
            <i class="fas fa-home"></i>
          </span>
          <b>{{ $t('about.title') }}</b>
        </router-link>
      </div>
      <div class="column has-text-centered">
        <router-link :to="'/' + $i18n.locale + '/contact'"> <span class="is-link"><b>{{ $t('contact.title') }}</b></span></router-link>
      </div>
      <div class="column has-text-centered">
        <router-link :to="'/' + $i18n.locale + '/links'"><b>{{ $t('links.title') }}</b></router-link>
      </div>
      <div class="column has-text-centered">
        <a @click="$i18n.locale = 'en'"><router-link :to="'/en/'"><country-flag country='gbr' size='normal'/></router-link></a>
      </div>
      <div class="column has-text-centered">
        <a @click="$i18n.locale = 'pt'"><router-link :to="'/pt/'" ><country-flag country='pt' size='normal' /></router-link></a>
      </div>
    </div>
    <!-- <ul style="margin-right: 20px;">
      <li>
        <router-link :to="'/' + $i18n.locale + '/'">
          <span class="icon is-small is-left is-home">
            <i class="fas fa-home"></i>
          </span>
          <b>{{ $t('home.title') }}</b>
        </router-link> |
      </li>
      <li v-if="this.$i18n.locale === 'pt'">
        <router-link :to="'/' + $i18n.locale + '/contactos'"><b>Contactos</b></router-link> |
      </li>
      <li v-if="this.$i18n.locale === 'pt'">
        <router-link :to="'/' + $i18n.locale + '/ligacoes'"><b>Ligações</b></router-link> |
      </li>
      <li class="is-pointer" @click="$i18n.locale = 'pt'">
        <router-link :to="'/pt/'"><country-flag country='pt' size='medium' /></router-link> |
      </li>
      <li class="is-pointer" @click="$i18n.locale = 'en'">
        <router-link :to="'/en/'"><country-flag country='gbr' size='medium'/></router-link>
      </li>
    </ul>-->
  </div>
</template>

<script>
export default {
  name: "TopBar"
}
</script>

<style scoped>
.topbar {
  background: #ebebeb;
  text-decoration: none;
  margin:0;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.topbar ul{
  display: block;
  height: 100px;
  padding: 20px 10px 0 860px;
  margin:0;
}

.topbar ul li {
  display: inline;
}

.topbar ul li a {
  text-decoration: none;
  color:#0f0f0f;
}

.is-home{
  padding-right: 6px;
}

.is-link {
  padding-top: 18px;
}

.is-pointer{
  text-decoration: none;
}

.is-menu{
  height: 80px;
  padding-top: 20px;
}

.is-menu .column a{
  text-decoration: none;
  color: #0f0f0f;
}

</style>